import React, { FC } from 'react';
import styled from 'styled-components';

import ProsperCard from '../../assets/icons/prosper-card.svg';
import { CARD_SERVICING_PATHS, MOBILE_BREAKPOINT, colors } from '../constants';
import { goToDashaboard } from '../utilities/routes';
import { pxToRem } from '../utilities/utility';

import { PrimaryButton, InlineButton } from './Button';
import Heading from './Heading';
import { ModalVaraintProps, ModalWrapper } from './ModalWrapper';

// Styles -----------------------------------------------------------------------------------------
const CompletedApplicationModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border-radius: 0.25rem;
  position: relative;
  padding: ${pxToRem(43)} ${pxToRem(58)};
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
    padding: 3.25rem 0;
  }
`;
CompletedApplicationModalContent.displayName =
  'CompletedApplicationModalContent';

const ProsperCardIcon = styled(ProsperCard)`
  margin-bottom: 1.75rem;
  @media (max-height: ${MOBILE_BREAKPOINT}) {
    width: 3.0625rem;
    height: 3.25rem;
    margin-bottom: 0.625rem;
  }
`;

// conditional div that allows subtext and phone number on the same line
const SubTextContainer = styled.div`
  margin: 1.25rem 2rem 2.5rem;
  @media (max-height: ${MOBILE_BREAKPOINT}) {
    margin: 0.25rem 0 1rem;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 1rem 2.75rem 2.5rem;
  }
`;
SubTextContainer.displayName = 'SubTextContainer';

const SubText = styled.p`
  color: ${colors.TEXT_PRIMARY};
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: center;
`;
SubText.displayName = 'SubText';

const ContinueButton = styled(PrimaryButton)`
  margin-top: ${pxToRem(31)};
  padding: ${pxToRem(16)} ${pxToRem(32)};
`;
ContinueButton.displayName = 'ContinueButton';

const ContinueTextButton = styled(InlineButton)`
  width: 4.375rem;
  color: ${colors.TEXT_PRIMARY};
`;
ContinueTextButton.displayName = 'ContinueTextButton';

// Component --------------------------------------------------------------------------------------
export const CompletedApplicationModalVariant: FC<ModalVaraintProps> = ({
  showModal,
  setShowModal,
  isMigrationNeeded,
  email,
}) => {
  const redirectToCompletedApplicationPage = () => {
    // redirect user to their dashboard / Fiserv
    setShowModal(false);
    if (isMigrationNeeded) {
      window.location.href = `${CARD_SERVICING_PATHS.welcome}`;
      sessionStorage.setItem('migrationEmail', email);
      return;
    }
    window.location.href = goToDashaboard();
  };

  return (
    <ModalWrapper
      showModal={showModal}
      setShowModal={setShowModal}
      disallowClose={false}
      shouldReturnFocusAfterClose={false}
      borderRadius="10px"
      id="completed-application-modal"
    >
      <CompletedApplicationModalContent>
        <ProsperCardIcon />
        <Heading>You already have a</Heading>
        <Heading>Prosper® Card!</Heading>
        <ContinueButton
          id="completed-application-modal-continue-button"
          onClick={redirectToCompletedApplicationPage}
          aria-label="Go to your Dashboard"
        >
          Go to account
        </ContinueButton>
      </CompletedApplicationModalContent>
    </ModalWrapper>
  );
};
